// extracted by mini-css-extract-plugin
export default {"deleteButton":"EditNotificationModalContent-deleteButton-zgPAx Button-button-paJ9a Link-link-RInnp","message":"EditNotificationModalContent-message-TWNtp Alert-alert-_KgnQ"};